import { createContext } from "react";
import { IStructure } from "../interfaces/structure";

const structureContext = createContext<IStructure>({} as IStructure)

export default structureContext